export default __webpack_public_path__ + "4285841eaf6a5853785b61a34beefe65.png";